import { createElement } from './utilities.js';

//=====================================================================
// Build the overlay
//=====================================================================
export const buildModalOverlay = (body) => {
    const overlayDiv = createElement('div',
        ['cModal__overlay'],
        {
            'dataModalOverlay': '',
            'aria-label': 'close',
            'aria-hidden': 'true',
        });
    body.appendChild(overlayDiv);

    // return the item into modalJS()
    return overlayDiv;
}